import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postPreferenceFailure,
  postPreferenceSuccess,
} from "../slices/features/postPreference";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postPreferenceSaga(action: any) {
  const { payload } = action;
  const { data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.postPreference,
      baseUrl,
      data
    );
    yield put(postPreferenceSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postPreferenceFailure({ statusCode, statusText }));
  }
}

export function* watchPostPreference() {
  yield takeLatest(RequestTypes.POST_PREFERENCE_REQUEST, postPreferenceSaga);
}
